export default __webpack_public_path__ + "static/media/BG.15853c69.png";